<template>
  <naj-modal
    ref="updateAttorneyDetailsModal"
    :title="local.attorney.updateAttorneyDetailsModalTitle"
    :width="900"
    :persistent="true"
    :footer="true"
    :show-footer-close-button="false"
    transition="scroll-x-transition"
    content-class="dialog-content-class"
    @onClose="closeModal"
  >
    <div class="case-info-text">
      <v-form ref="updateAttorneyDetailsForm">
        <v-row>
          <v-col>
            <naj-alert type="alert">
              <template slot="content">
                <span class="caution-content"> {{ local.attorney.updateAttorneyDetailsText }}</span>
              </template>
            </naj-alert>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <naj-input
              :type-id="formFieldType.radioButton"
              :label="local.common.selectOption"
              :value.sync="formModel.actionType"
              :items="attorneyActionTypes"
              item-text="name"
              item-value="id"
              :disabled="viewMode"
              validates="required"
              class="radio-button-option-linear"
            ></naj-input>
          </v-col>
        </v-row>
        <template v-if="formModel.actionType == attorneyActions.updateAttorneyDetails">
          <v-row>
            <v-col cols="3">
              <naj-input
                :type-id="formFieldType.radioButton"
                :label="local.attorney.representationTypes"
                :value.sync="partyRoleId"
                :items="representationTypes"
                item-text="name"
                item-value="id"
                :disabled="true"
                class="radio-button-option-linear"
                validates="required"
              ></naj-input>
            </v-col>
          </v-row>
          <v-row v-if="formModel.isTraineeLawyer">
            <v-col>
              <naj-input
                :type-id="formFieldType.checkbox"
                :value="formModel.isTraineeLawyer"
                :label="local.attorney.traineeLawyer"
                class="inline-label primary-label-color pledged"
                :disabled="true"
              ></naj-input>
            </v-col>
          </v-row>
          <v-row v-if="!formModel.isTraineeLawyer">
            <v-col>
              <naj-input
                :type-id="formFieldType.radioButton"
                :label="local.attorney.type"
                :value.sync="formModel.attorneyTypeId"
                :items="attorneyTypes"
                item-text="name"
                item-value="id"
                :disabled="viewMode"
                :validates="`required:${local.attorney.invalidNumber}`"
                class="radio-button-option-linear"
                @change="attorneyTypeChanged"
              ></naj-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              v-if="!formModel.isTraineeLawyer"
              cols="6"
            >
              <naj-input
                :type-id="formFieldType.number"
                :label="`${isInternalAttorney ? local.attorney.number : local.attorney.approvalNumber}`"
                :value.sync="formModel.attorneyNumber"
                :validates="`required|long|isValid:${local.attorney.invalidNumber},${isNumberValid}|isVerified:${isVerifiedAttorneyNumber}`"
                :disabled="viewMode"
                @input="changeVerificationAttorney('isVerifiedAttorneyNumber', formModel.attorneyNumber)"
              >
              </naj-input>
            </v-col>
            <v-col
              v-if="formModel.casePartyRole == casePartyRoleEnum.lawyer && formModel.isTraineeLawyer"
              cols="4"
            >
              <naj-input
                :type-id="formFieldType.number"
                :label="local.attorney.originalAttorneyCode"
                :value.sync="formModel.originalAttorneyCode"
                :validates="`required|long|isValid:${local.attorney.invalidNumber},${isNumberValid}|isVerified:${isVerifiedOriginalCode}`"
                :disabled="viewMode"
                @input="changeVerificationAttorney('isVerifiedOriginalCode', formModel.originalAttorneyCode)"
              ></naj-input>
            </v-col>
            <v-col
              v-if="formModel.casePartyRole == casePartyRoleEnum.lawyer && formModel.isTraineeLawyer"
              cols="4"
            >
              <naj-input
                :type-id="formFieldType.number"
                :label="local.attorney.secondaryAttorneyCode"
                :value.sync="formModel.secondaryAttorneyCode"
                :validates="`required|long|isValid:${local.attorney.invalidNumber},${isNumberValid}|isVerified:${isVerifiedSecondaryCode}`"
                :disabled="viewMode"
                @input="changeVerificationAttorney('isVerifiedSecondaryCode', formModel.secondaryAttorneyCode)"
              ></naj-input>
            </v-col>
            <v-col
              cols="3"
              class="d-flex align-center"
            >
              <naj-button
                v-if="!hideValidateAttorney"
                square
                inputs-alignment
                :loading="isChecking"
                :disabled="!isCheckingValidityValid"
                @click="validateAttorneyNumber"
              >
                {{ local.common.check }}
              </naj-button>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <naj-input
                :type-id="formFieldType.editableMultipleSelectBox"
                :label="local.attorney.originalCasePartyName"
                :placeholder="local.common.select"
                :value.sync="selectedClientIds"
                :chips-model="selectedAttorneyClients"
                :items="attorneyClients"
                :remove-all-chips="removeAllChips"
                item-text="name"
                item-value="identityNumber"
                :disabled="!(attorneyClients.length > 0 && enableSelectCaseParties)"
                validates="required"
              ></naj-input>
            </v-col>
          </v-row>
        </template>
        <v-row v-if="formModel.actionType == attorneyActions.submitRemoveRepresentativeRequest">
          <v-col>
            <naj-alert type="error">
              <template slot="content">
                <span class="caution-content"> {{ local.attorney.DeleteTheAgencyOnThisCaseMassage }}</span>
              </template>
            </naj-alert>
          </v-col>
        </v-row>
      </v-form>
    </div>
    <template
      slot="actions"
      slot-scope="{ closeNajModal }"
    >
      <div>
        <naj-button
          :disabled="loading"
          class="btn-style"
          @click="submitUpdatedAttorneyDetails(closeNajModal)"
        >
          {{ local.common.saveAndSend }}
        </naj-button>

        <naj-button
          outlined
          @click="closeModal"
        >
          {{ local.common.close }}
        </naj-button>
      </div>
    </template>
  </naj-modal>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapLUTState } = createNamespacedHelpers('LookupsModule');
const { mapActions: mapCasesActions } = createNamespacedHelpers('CasesModule');
import { writingsOfJusticeEnum, attorneyActions, RequestTypesNames, casePartyRoleEnum, representationTypeSelection } from '@/helpers/enum.js';

export default {
  components: {},
  props: {
    modalVisibility: {
      default: false,
      type: Boolean,
      required: false,
    },
    formModel: {
      required: true,
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      loading: false,
      viewMode: false,
      isChecking: false,
      isPega: true,
      attorneyActions,
      RequestTypesNames,
      attorneyDetails: {},
      attorneyClients: [],
      selectedClientIds: [],
      isTraineeLawyer: true,
      partyRoleId: null,
      casePartyRoleEnum,
      removeAllChips: false,
      hideValidateAttorney: false,
      closeStateModal: true,
      enableSelectCaseParties: false,
      selectedAttorneyClients: [],
    };
  },
  computed: {
    ...mapLUTState(['attorneyTypes', 'attorneyActionTypes', 'representationTypes']),
    isCheckingValidityValid() {
      if (this.formModel.casePartyRole == casePartyRoleEnum.lawyer && this.formModel.isTraineeLawyer) {
        return this.formModel.originalAttorneyCode && this.formModel.secondaryAttorneyCode;
      }
      return this.formModel.attorneyNumber;
    },
    isNumberValid() {
      return this.formModel.attorneyNumber !== 0;
    },
    isVerifiedOriginalCode() {
      return this.formModel.isVerifiedOriginalCode;
    },
    isVerifiedSecondaryCode() {
      return this.formModel.isVerifiedSecondaryCode;
    },
    isVerifiedAttorneyNumber() {
      return this.formModel.isVerifiedAttorneyNumber;
    },
    isInternalAttorney() {
      // eslint-disable-next-line eqeqeq
      return this.formModel.attorneyTypeId == writingsOfJusticeEnum.internalAttorney;
    },
    isExternalAttorney() {
      // eslint-disable-next-line eqeqeq
      return this.formModel.attorneyTypeId == writingsOfJusticeEnum.externalAttorney;
    },
  },
  watch: {

    modalVisibility(newVal) {
      if (this.formModel.casePartyRole == casePartyRoleEnum.lawyer)
        this.partyRoleId = representationTypeSelection.lawyerSelection;

      if (this.formModel.casePartyRole != casePartyRoleEnum.lawyer)
        this.partyRoleId = representationTypeSelection.representativeSelection;

      if (newVal) {
        this.$set(
          this.formModel,
          'attorneyTypeId',
          this.formModel.attorneyTypeId || writingsOfJusticeEnum.internalAttorney
        );
        this.$set(
          this.formModel,
          'attorneyTypeId',
          this.formModel.attorneyTypeId || writingsOfJusticeEnum.internalAttorney
        );
        this.$refs.updateAttorneyDetailsModal.show();
      } else {
        this.$refs.updateAttorneyDetailsModal.close();
      }
    },
  },
  methods: {
    ...mapCasesActions([
      'updateCasePartyAttorney',
      'validateAttorneyAgainstCaseParties',
      'validateAttorneyTraineeLawyer',
      'removeAgencyFromCase',
    ]),
    validateAttorneyNumber() {
      this.isChecking = true;
      this.attorneyTypeChanged();
      if (this.formModel.casePartyRole == casePartyRoleEnum.lawyer && this.formModel.isTraineeLawyer) {
        if (!this.formModel.originalAttorneyCode && !this.formModel.secondaryAttorneyCode) { this.isChecking = false; return false; }
        const payload = {
          originalAttorneyCode: this.formModel.originalAttorneyCode,
          secondaryAttorneyCode: this.formModel.secondaryAttorneyCode,
          attorneyType: this.formModel.attorneyTypeId,
          caseObjectKey: this.formModel.caseObjectKey,
        };
        this.validateAttorneyTraineeLawyer(payload)
          .then(({ data }) => {
            this.$set(this, 'attorneyDetails', data.attorneyDetails);
            this.$set(this, 'attorneyClients', data.attorneyClients);
            this.removeAllChips = false;
            this.enableSelectCaseParties = data.enableSelect;
            if (!data.enableSelect) {
              this.selectedAttorneyClients = data.attorneyClients;
              this.selectedClientIds = data.attorneyClients.map(a => a.identityNumber);
            }
            this.toaster.success(this.local.common.verificationSucceeded, 2);
            this.hideValidateAttorney = true;
            this.changeVerification(true);
          })
          .finally(() => (this.isChecking = false));
      }
      else {
        const payload = {
          attorneyCode: this.formModel.attorneyNumber,
          attorneyType: this.formModel.attorneyTypeId,
          caseObjectKey: this.formModel.caseObjectKey,
        };
        this.validateAttorneyAgainstCaseParties(payload)
          .then(({ data }) => {
            this.$set(this, 'attorneyDetails', data.attorneyDetails);
            this.$set(this, 'attorneyClients', data.attorneyClients);
            this.enableSelectCaseParties = data.enableSelect;

            if (!data.enableSelect) {
              this.selectedAttorneyClients = data.attorneyClients;
              this.selectedClientIds = data.attorneyClients.map(a => a.identityNumber);
            }
            this.removeAllChips = false;
            this.toaster.success(this.local.common.verificationSucceeded, 2);
            this.hideValidateAttorney = true;
            this.changeVerification(true);
          })
          .finally(() => (this.isChecking = false));
      }
    },
    changeVerificationAttorney(key, formModelInput) {
      this.hideValidateAttorney = false;
      this.attorneyTypeChanged();
      if (formModelInput) {
        this.$set(this.formModel, key, true);
      } else {
        this.$set(this.formModel, key, false);
      }
    },
    attorneyTypeChanged() {
      this.$set(this, 'attorneyDetails', {});
      this.$set(this, 'attorneyClients', []);
      this.removeAllChips = true;
    },
    updateAttorney() {
      const clientsCaseParties = this.attorneyClients.filter(client => this.selectedClientIds.some(sc => sc == client.identityNumber)) || [];
      if (this.formModel.casePartyRole == casePartyRoleEnum.lawyer && this.formModel.isTraineeLawyer) {
        const payload = {
          updateOrRemoveAttorney: this.formModel.actionType,
          casePartyId: this.formModel.casePartyId,
          casePartyIdentityNumber: this.formModel.casePartyIdentityNumber,
          attorneyNumber: this.formModel.secondaryAttorneyCode,
          mainLawyerAttorneyNumber: this.formModel.originalAttorneyCode,
          attorneyTypeId: this.formModel.attorneyTypeId,
          caseObjectKey: this.formModel.caseObjectKey,
          clientsCasePartiesIds: clientsCaseParties.map(a => a.casePartyId),
          isTrainer: this.formModel.isTraineeLawyer,
        };
        this.updateCasePartyAttorney(payload).then(() => {
          this.toaster.success(this.local.agentForm.successCode, 2);
          this.closeStateModal = false;
          this.$emit('casePartyAttorneyUpdate');
        }).finally(() => (this.loading = false));
      }
      else {
        const payload = {
          updateOrRemoveAttorney: this.formModel.actionType,
          casePartyId: this.formModel.casePartyId,
          casePartyIdentityNumber: this.formModel.casePartyIdentityNumber,
          attorneyNumber: this.formModel.attorneyNumber,
          attorneyTypeId: this.formModel.attorneyTypeId,
          caseObjectKey: this.formModel.caseObjectKey,
          clientsCasePartiesIds: clientsCaseParties.map(a => a.casePartyId),
        };
        this.updateCasePartyAttorney(payload).then(() => {
          this.toaster.success(this.local.agentForm.successCode, 2);
          this.closeStateModal = false;
          this.$emit('casePartyAttorneyUpdate');
        }).finally(() => (this.loading = false));
      }
    },
    removeAttorney() {
      const payload = { caseObjectKey: this.formModel.caseObjectKey };
      this.removeAgencyFromCase(payload).then(() => {
        this.toaster.success(this.local.agentForm.removeAttorneyMessage, 2);
        this.closeModal();

      }).catch((err) => {
        this.toaster.error(err.message);
      })
        .finally(() => (this.loading = false));
    },
    submitUpdatedAttorneyDetails() {
      this.$refs.updateAttorneyDetailsForm.$validator.validateAll()
        .then((isValid) => {
          if (isValid) {
            this.loading = true;
            if (this.formModel.actionType === attorneyActions.updateAttorneyDetails)
              this.updateAttorney();
            else this.removeAttorney();
          }
        });
    },
    closeModal() {
      if (this.closeStateModal)
        this.$router.push({ path: '/' });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .radio-button-option-linear {
  .v-input--radio-group {
    .radio-button-option {
      background: #fff;
      border-top: 0px solid #fff;
      border-bottom: 0px solid #fff;
      font-weight: bold;
      padding: unset;

      &:first-child {
        border-right: 0px solid #fff;
        padding-left: 50px;
      }

      &:last-child {
        border-left: 0px solid #fff;
      }
    }

    .v-messages {
      display: none;
    }
  }

  .v-input--radio-group .v-input--radio-group__input > .v-label {
    text-align: right;
    font-weight: bold;
  }

  .v-input.v-input--selection-controls .v-label {
    font-size: 19px;
  }
}

.case-info-text {
  max-height: 100%;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.case-info-text::-webkit-scrollbar {
  display: none; /* Hide scrollbar for Chrome, Safari and Opera */
}

.caution-content {
  font-weight: bold;
}

::v-deep .v-alert__wrapper {
  padding: unset !important;
}

::v-deep .naj-box-contnet {
  padding-top: unset !important;
}

::v-deep .naj-box .naj-box-contnet {
  padding-top: unset !important;
}

.v-input .v-label {
  font-weight: bold;
}

::v-deep .v-input {
  &.v-text-field--outlined {
    .v-label {
      font-weight: bold !important;
    }
  }
}

::v-deep .v-input.v-text-field--outlined .v-label {
  font-weight: bold;
}

::v-deep .v-input.v-text-field--outlined .v-input__slot {
  min-height: 25px;
}

::v-deep .v-icon.v-icon {
  font-size: 15px !important;
}
</style>